<template>
  <div>
    <div
      class="row">
      <div 
        v-for="(col, colIndex) in inputsChunked"
        :key="'col_' + colIndex"
        class="col">
        <div
          v-for="(input, inputIndex) in col"
          :key="inputIndex" 
          class="form-group row">
          <label 
            class="col-sm-4 col-form-label" 
            :for="input.id">
            {{input.label}}
          </label>
          <div class="col-sm-8">
              <input v-if="input.type == 'text'"
                     type="text"
                     class="form-control form-control-sm"
                     :id="input.id"
                     :ref="input.id"
                     :placeholder="input.placeholder">

              <select v-if="input.type == 'select'"
                      class="form-control  form-control-sm"
                      :id="input.id"
                      :ref="input.id">
                  <option value="null">
                      {{input.placeholder || 'SELECT...'}}
                  </option>
                  <option v-for="(option, index) in input.options"
                          :key="input.id + index"
                          :value="index">
                      {{option.label}}
                  </option>
              </select>

              <datepicker 
                     v-if="input.type == 'datepicker'"
                     :id="input.id"
                     :ref="input.id"
                     :format="input.customFormatter"
                     inputClass="form-control form-control-sm" />

          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div
            class="float-right">
            <button type="reset" class="btn btn-secondary mr-2" @click="handleClearClick()">Clear</button>
            <button type="submit" class="btn btn-primary" @click="handleSubmitClick()">Search</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import datepicker from '@/components/taurus-datepicker/components/Datepicker.vue'

const chunk = (arr, chunkSize, cache = []) => {
    const tmp = [...arr]
    while (tmp.length) cache.push(tmp.splice(0, chunkSize))
    return cache
}

export default {
  name: 'SearchForm',
  props: {
   inputs: Array
  },
  components: {
      datepicker
  },
  computed: {
    inputsChunked () {
      let tmp = this.inputs.length / 3
      return chunk (this.inputs, Math.ceil(tmp))
    }
  },
  methods: {
    handleClearClick() {
        for (var i = 0; i < this.inputs.length; i++) {
            if (this.inputs[i].type == 'text') {
                this.$refs[this.inputs[i].id][0].value = null
            }

            if (this.inputs[i].type == 'select') {
                this.$refs[this.inputs[i].id][0].value = null
            }
            if (this.inputs[i].type == 'datepicker') {
                this.$refs[this.inputs[i].id][0].clearDate()
            }
        }

        this.$emit('clear', { componentKey: this.$vnode.key })
    },
    handleSubmitClick () {      
      let search = {}

      for ( var i = 0; i < this.inputs.length; i++ ) {
        if (this.inputs[i].type == 'text') {
          let val = this.$refs[this.inputs[i].id][0].value
          search[this.inputs[i].id] = val == '' ? null : val
        }

          if (this.inputs[i].type == 'select') {
              if (this.inputs[i].options) {
                  search[this.inputs[i].id] = {
                      ...this.inputs[i].options[this.$refs[this.inputs[i].id][0].value]
                  }
              } else {
                  search[this.inputs[i].id] = null
              }
          
        }
        if (this.inputs[i].type == 'datepicker') {
            let dte = new Date(this.$refs[this.inputs[i].id][0].selectedDate)
            if (dte != new Date('1970-01-01T00:00:00.000Z')) {
                search[this.inputs[i].id] = dte
            }
        }
      }

      this.$emit('search', { componentKey: this.$vnode.key, ...search })
    }
  }
}

</script>

<style scoped>
</style>
